module.exports = {"130624100":"阜平镇","130624101":"龙泉关镇","130624102":"平阳镇","130624103":"城南庄镇","130624104":"天生桥镇","130624105":"王林口镇","130624202":"台峪乡","130624203":"大台乡","130624204":"史家寨乡","130624205":"砂窝乡","130624206":"吴王口乡","130624207":"夏庄乡","130624208":"北果元乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130624.json
// module id = 158
// module chunks = 0